/**
 * Tiny module-level pub/sub for "is a trip recording right now?".
 *
 * Lives outside React state because the consumer (`version-sync`)
 * needs to peek synchronously from a non-component context and
 * also subscribe to changes. A React Context would force every
 * consumer to be a component — overkill here.
 *
 * Single source of truth: only `RecordPage` calls `setRecording`.
 * Everyone else reads via `getRecording` / `onRecordingChange`.
 */

let recording = false;
const listeners = new Set<(value: boolean) => void>();

export function setRecording(value: boolean): void {
  if (recording === value) return;
  recording = value;
  for (const listener of listeners) {
    try {
      listener(value);
    } catch {
      // Swallow listener errors — one bad listener mustn't break the
      // others. The listener is responsible for its own logging.
    }
  }
}

export function getRecording(): boolean {
  return recording;
}

export function onRecordingChange(cb: (value: boolean) => void): () => void {
  listeners.add(cb);
  return () => {
    listeners.delete(cb);
  };
}
